import TransferEmployeeTypes from './TransferEmployee.types';

export const transferEmployeeStart = (data: any) => ({
	type: TransferEmployeeTypes.TRANSFER_EMPLOYEE_START,
	payload: data,
});

export const transferEmployeeSuccess = (data: any) => ({
	type: TransferEmployeeTypes.TRANSFER_EMPLOYEE_SUCCESS,
	payload: data,
});

export const transferEmployeeFailure = (error: unknown) => ({
	type: TransferEmployeeTypes.TRANSFER_EMPLOYEE_FAILURE,
	payload: error,
});

export const transferEmployeeResponseChanged = () => ({
	type: TransferEmployeeTypes.TRANSFER_EMPLOYEE_RESPONSE_CHANGED,
});

export const transferEmployeeResponseRestStart = () => ({
	type: TransferEmployeeTypes.TRANSFER_EMPLOYEE_RESPONSE_REST_START,
});

// Get All Transfers Actions
export const getAllTransfersStart = (data: any) => ({
	type: TransferEmployeeTypes.GET_ALL_TRANSFERS_START,
	payload: data,
});

export const getAllTransfersSuccess = (data: any) => ({
	type: TransferEmployeeTypes.GET_ALL_TRANSFERS_SUCCESS,
	payload: data,
});

export const getAllTransfersFailure = (error: unknown) => ({
	type: TransferEmployeeTypes.GET_ALL_TRANSFERS_FAILURE,
	payload: error,
});

export const getAllTransfersResponseRestStart = () => ({
	type: TransferEmployeeTypes.GET_ALL_TRANSFERS_RESPONSE_REST_START,
});

// Delete Transfer Actions
export const deleteTransferStart = (data: any) => ({
	type: TransferEmployeeTypes.DELETE_TRANSFER_START,
	payload: data,
});

export const deleteTransferSuccess = (data: any) => ({
	type: TransferEmployeeTypes.DELETE_TRANSFER_SUCCESS,
	payload: data,
});

export const deleteTransferFailure = (error: unknown) => ({
	type: TransferEmployeeTypes.DELETE_TRANSFER_FAILURE,
	payload: error,
});

export const deleteTransferResponseRestStart = () => ({
	type: TransferEmployeeTypes.DELETE_TRANSFER_RESPONSE_REST_START,
});
